<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <fuse-sidebar class="sidebar" name="note-list-sidebar" position="left" lockedOpen="gt-md">
        <note-list-sidebar></note-list-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div id="about" class="p-24" fxLayout="row wrap" style="overflow-y: scroll;">

            <div class="about-content" fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="65" *ngFor="let note of rows">

                <div class="profile-box info-box general" fxLayout="column">

                    <header class="accent">
                        <div class="title">{{note.title}}</div>
                    </header>

                    <div class="content">
                        <div class="info-line">
                            <div class="title">{{'Created'|translate}}</div>
                            <div class="info">
                                {{note.createdAt|date: 'd.MM.y H:mm':'UTC': 'pl'}}
                                {{'by'|translate}} {{note.createdBy.firstName}} {{note.createdBy.lastName}} ({{note.createdBy.username}})
                            </div>
                        </div>

                        <div class="info-line">
                            <div class="title">{{'Description'|translate}}</div>
                            <div class="info">
                                {{note.description}}
                                <br/><br/>
                                <a title="{{'Response'|translate}}" style="cursor: pointer;" (click)="responseNote(note)">
                                    <i class="icon-message"></i>
                                </a>&nbsp;
                                <a title="{{'Done'|translate}}" *ngIf="!note.confirmedAt" style="cursor: pointer;" (click)="confirmNote(note)">
                                    <i class="icon-done"></i>
                                </a>&nbsp;
                                <a title="{{'Delete'|translate}}" *ngIf="note.confirmedAt && note.confirmedAt.length>0" style="cursor: pointer;" (click)="deleteNote(note)">
                                    <i class="icon-delete_forever"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>
</div>
